// Light, dark, or whatever the system is set to (the default). The choice is
// kept in this browser; Views/Shared/_ThemeScript.cshtml applies it before the
// page paints, and this store changes it and follows the system setting:
// <html data-theme="light|dark"> switches the colour tokens (Assets/css/tokens.css).
//
//   $store.theme.set('dark')   $store.theme.toggle()   $store.theme.choice / .dark

const KEY = 'theme';
const CHOICES = ['system', 'light', 'dark'];
const system = window.matchMedia('(prefers-color-scheme: dark)');

function stored() {
  try {
    const choice = localStorage.getItem(KEY);
    return CHOICES.includes(choice) ? choice : 'system';
  } catch {
    return 'system';
  }
}

export default (Alpine) => {
  Alpine.store('theme', {
    choice: stored(),
    dark: document.documentElement.dataset.theme === 'dark',

    init() {
      system.addEventListener('change', () => this.apply());

      // Changed in another tab.
      window.addEventListener('storage', (event) => {
        if (event.key === KEY || event.key === null) {
          this.choice = stored();
          this.apply();
        }
      });
    },

    set(choice) {
      this.choice = CHOICES.includes(choice) ? choice : 'system';

      try {
        if (this.choice === 'system') {
          localStorage.removeItem(KEY);
        } else {
          localStorage.setItem(KEY, this.choice);
        }
      } catch {
        // Private windows can refuse storage; the choice still applies to this page.
      }

      this.apply();
    },

    toggle() {
      this.set(this.dark ? 'light' : 'dark');
    },

    apply() {
      this.dark = this.choice === 'dark' || (this.choice === 'system' && system.matches);
      document.documentElement.dataset.theme = this.dark ? 'dark' : 'light';
    },
  });
};
